module.exports = __webpack_public_path__ + "img/Futurism-text.0dda75ee.jpg";